import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_WHITE } from "components/v3/primary-button/themes";

const BackButton = ({ backUrl }) => {
    if (!backUrl) {
        return null;
    }

    return (
        <Link tabIndex={ -1 } to={ decodeURIComponent(backUrl) }>
            <PrimaryButton type="button" text="Cancel" theme={ BUTTON_THEME_WHITE } />
        </Link>
    );
};

BackButton.propTypes = {
    backUrl: PropTypes.string
};

export default BackButton;
